import { ERROR_CODE_MESSAGES } from '../../../constants/errorCodeMessages';

export const downloadCSV = async (data, filename = 'campaign_report.csv', opts = {}) => {
  const { onProgress } = opts;
  if (!data?.length) return;

  const headers = [
    'campaign_id',
    'recipient_id',
    'status',
    'message_sent_at',
    'message_updated_at',
    'error_code',
    'error_title',
  ];

  const formatDate = (v) => {
    if (!v) return '';
    const d = new Date(v);
    return isNaN(d)
      ? String(v)
      : d.toLocaleString('en-IN', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
  };

  const parseError = (row) => {
    if (row.status !== 'failed' || !row.errors) return { code: '', title: '' };
    try {
      const parsed = typeof row.errors === 'string' ? JSON.parse(row.errors) : row.errors;
      const first = Array.isArray(parsed) ? parsed[0] : parsed;
      const code = first?.code || '';
      const title = ERROR_CODE_MESSAGES[parseInt(code, 10)] || first?.title || first?.message || '';
      return { code, title };
    } catch {
      return { code: '', title: '' };
    }
  };

  // Build rows in chunks to allow progress updates and keep UI responsive
  const total = data.length;
  const rows = [];
  const chunkSize = 500;
  for (let i = 0; i < total; i += chunkSize) {
    const chunk = data.slice(i, i + chunkSize);
    for (const row of chunk) {
      const { code, title } = parseError(row);
      const line = headers
        .map((field) => {
          let value;
          if (field === 'error_code') value = code;
          else if (field === 'error_title') value = title;
          else if (field === 'message_sent_at' || field === 'message_updated_at') value = formatDate(row[field]);
          else value = row[field] ?? '';
          return `"${String(value).replace(/"/g, '""')}"`;
        })
        .join(',');
      rows.push(line);
    }
    if (typeof onProgress === 'function') {
      onProgress(Math.min(100, Math.round(((i + chunk.length) / total) * 100)));
    }
    // Yield back to the UI thread
    await new Promise((r) => setTimeout(r, 0));
  }

  const csvContent = [headers.join(','), ...rows].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
